module.exports = __webpack_public_path__ + "static/media/myphoto13.a4e9cbaf.jpg";